/**
 * Spec 069: a empresa exige que todo atendente esteja num grupo de permissão, e esta pessoa não está em nenhum. O /me
 * diz o motivo (`permissionGroupRequired`); a tela não o deduz da lista de permissões vazia, que também pode ser um
 * grupo sem nenhuma permissão marcada. A API já recusa tudo o que pede permissão — aqui é só o aviso.
 */
export function mustAskForPermissionGroup(profile: { permissionGroupRequired?: boolean } | undefined): boolean {
  return profile?.permissionGroupRequired === true;
}

export const PERMISSION_GROUP_REQUIRED_TITLE = 'Você ainda não faz parte de um grupo de permissão';
export const PERMISSION_GROUP_REQUIRED_TEXT =
  'Peça ao administrador da sua empresa para incluir você em um grupo de permissão. Depois disso, entre de novo.';
